export default {
  data () {
    return {
      width: ''
    }
  },

  mounted () {
    // 초기화
    this.handleResize()

    // resize 이벤트 리스너 등록
    window.addEventListener('resize', this.handleResize)
  },
  beforeDestroy () {
    // 컴포넌트가 파괴되기 전에 리스너 제거
    window.removeEventListener('resize', this.handleResize)
  },

  created () {
    this.width = window.innerWidth
  },

  methods: {
    handleResize () {
      this.width = window.innerWidth
    }
  }
}
